var map = {
	"./drawing/connection-offline.svg": [
		1914,
		150
	],
	"./drawing/connection-online.svg": [
		1915,
		151
	],
	"./drawing/connection.svg": [
		1916,
		152
	],
	"./drawing/freepik_news.svg": [
		1917,
		153
	],
	"./drawing/status.svg": [
		1918,
		154
	],
	"./favicon/vsm-black.svg": [
		1919,
		155
	],
	"./img/announcement/plate-scan.svg": [
		1920,
		156
	],
	"./img/no-image.svg": [
		1921,
		157
	],
	"./svg/branding/logo-white.svg": [
		1922,
		619
	],
	"./svg/branding/logo.svg": [
		1923,
		618
	],
	"./svg/check.svg": [
		1924,
		620
	],
	"./svg/circle.svg": [
		1925,
		621
	],
	"./svg/dashboard/clock.svg": [
		1926,
		622
	],
	"./svg/dashboard/humidity.svg": [
		1927,
		623
	],
	"./svg/dashboard/leakage.svg": [
		1928,
		624
	],
	"./svg/dashboard/load.svg": [
		1929,
		625
	],
	"./svg/dashboard/metadata.svg": [
		1930,
		626
	],
	"./svg/dashboard/temp.svg": [
		1931,
		627
	],
	"./svg/dashboard/tool.svg": [
		1932,
		628
	],
	"./svg/error.svg": [
		1933,
		629
	],
	"./svg/eye.svg": [
		1934,
		630
	],
	"./svg/loader.svg": [
		1935,
		631
	],
	"./svg/markers/gray.svg": [
		1936,
		632
	],
	"./svg/markers/green.svg": [
		1937,
		633
	],
	"./svg/markers/red.svg": [
		1938,
		634
	],
	"./svg/markers/yellow.svg": [
		1939,
		635
	],
	"./svg/nfc.svg": [
		1940,
		636
	],
	"./svg/small-spinner.svg": [
		1941,
		637
	],
	"./svg/spinner.svg": [
		1942,
		638
	],
	"./svg/states/gray.svg": [
		1943,
		639
	],
	"./svg/states/green.svg": [
		1944,
		640
	],
	"./svg/states/red.svg": [
		1945,
		641
	],
	"./svg/states/yellow.svg": [
		1946,
		642
	],
	"./svg/tea-loader.svg": [
		1947,
		643
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1066;
module.exports = webpackAsyncContext;